import { ReadWritePermissions } from '../../../../Auth/components/DataModelGate';

export function isRequired(permissions: ReadWritePermissions): boolean {
  return permissions.write === 'MANDATORY';
}

export function toRequiredLabel(label: string, permissions: ReadWritePermissions): string {
  return `${label}${isRequired(permissions) ? '*' : ''}`;
}
